// src/pages/Dashboard/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import Header from '../../components/layout/Header/Header';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import Footer from '../../components/layout/Footer/Footer';
import '../../../src/styles.css';

const drawerWidth = 280;
const collapsedWidth = 80; // width when collapsed
const headerHeight = 70;

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  // On small screens, sidebar is controlled by mobileOpen
  // On large screens, sidebar is controlled by sidebarOpen
  const handleDrawerToggle = () => {
    if (isSmallScreen) {
      setMobileOpen(!mobileOpen);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  // Reset mobile drawer when switching to desktop
  useEffect(() => {
    if (!isSmallScreen) {
      setMobileOpen(false);
    }
  }, [isSmallScreen]);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f7f9fb', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <CssBaseline />
      {/* Sidebar */}
      <Sidebar
        isSmallScreen={isSmallScreen}
        sidebarOpen={isSmallScreen ? mobileOpen : sidebarOpen}
        toggleSidebar={handleDrawerToggle}
        collapsed={!isSmallScreen && !sidebarOpen}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
      />
      {/* Header */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: { xs: 0, md: sidebarOpen ? `${drawerWidth}px` : `${collapsedWidth}px` },
          width: { xs: '100%', md: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)` },
          zIndex: 1201,
          transition: 'left 0.3s, width 0.3s',
        }}
      >
        <Header handleDrawerToggle={handleDrawerToggle} />
      </Box>
      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 3 },
          width: { xs: '100%', md: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)` },
          maxWidth: '100%',
          ml: { xs: 0, md: sidebarOpen ? `${drawerWidth}px` : `${collapsedWidth}px` },
          mt: `${headerHeight}px`,
          minHeight: `calc(100vh - ${headerHeight}px)`,
          transition: 'margin 0.3s, width 0.3s',
          overflowX: 'hidden',
        }}
      >
        {/* <Toolbar /> This creates space for the fixed header */}
        {children}
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;